<template>
<moo-dialog
    width="100%"
    :visible.sync="visible"
    :append-to-body="true"
    :modal-append-to-body="false"
    :show-close="false"
    custom-class="image-preview"
    @closed="onDialogClosed"
  >
    <div id="image-preview-body-id" class="image-preview-body">
      <IPHeader
        class="ip-header"
        :file-name="current.fileName"
        @close="dismiss"
      ></IPHeader>
      <div id="image-box-swiper" class="swiper">
        <div id="swiper-wrapper-id" class="swiper-wrapper">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="swiper-slide"
          >
            <ImageBox
              v-if="item && shouldRenderImage(index)"
              :key="item.fileId"
              :img-src="loadUrl(item)"
              :loading="loading"
              :zoom-percent="zoomPercent"
              :img-rotate="imgRotate"
              :show="item.fileId === current.fileId"
              class="content-body"
              @next="onNext"
              @prev="onPrev"
              @download="onDownload"
              @before-load="loading = true"
              @after-load="loading = false"
              @error="onError"
            ></ImageBox>
          </div>
        </div>
      </div>
      <ToolsBar
        v-if="current && visible"
        class="ip-tools-bar"
        :can-next="canNext"
        :can-prev="canPrev"
        :loading="loading"
        :can-download="canDownload"
        :zoom-percent="zoomPercent"
        :img-rotate="imgRotate"
        @next="onNext"
        @prev="onPrev"
        @download="onDownload"
        @zoom-in="onZoomIn"
        @zoom-out="onZoomOut"
        @rotate="onRotate"
        @before-load="loading = true"
        @after-load="loading = false"
      ></ToolsBar>
    </div>
  </moo-dialog>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { Swiper } from "swiper";
import "swiper/css";
import IPHeader from "./components/header.vue";
import ImageBox from "./components/imagebox.vue";
import ToolsBar from "./components/toolsbar.vue";

export default {
  components: {
    IPHeader,
    ImageBox,
    ToolsBar
  },
  data() {
    return {
      visible: false,
      current: {},
      items: [],
      callback: null,
      loading: false,
      swiper: null,
      sourceIndex: 0,
      zoomPercent: 1,
      imgRotate: 0
    };
  },
  computed: {
    loadUrl() {
      return (item) => item?.previewUrl || "";
    },
    canDownload() {
      return this.current.auth && this.current.auth !== "READ";
    },
    canNext() {
      return this.sourceIndex < this.items.length - 1;
    },
    canPrev() {
      return this.sourceIndex > 0;
    }
  },
  methods: {
    swiperDestroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },
    dismiss() {
      this.visible = false;
    },
    onDialogClosed() {
      this.swiperDestroy();
      this.resetPreviewState();
    },
    show(options) {
      if (!options.current) {
        this.$message({
          message: intl.$t("图片加载失败#!!!#src/pages/H5/Cloud/components/imagepreview/template.vue_1"),
          type: "error",
          duration: 2000
        });
        return;
      }

      this.visible = true;
      this.current = options.current;
      this.items = options.items?.length ? options.items : [options.current];
      this.callback = options.callback;
      const currentSwiperIndex = this.items.findIndex(
        (item) => item.fileId === options.current.fileId
      );
      this.sourceIndex = currentSwiperIndex === -1 ? 0 : currentSwiperIndex;
      this.zoomPercent = 1;
      this.imgRotate = 0;

      this.$nextTick(() => {
        this.swiperDestroy();
        const swiper = new Swiper("#image-box-swiper", {
          direction: "horizontal",
          init: false,
          lazyPreloadPrevNext: 2,
          initialSlide: this.sourceIndex,
          passiveListeners: false,
          touchMoveStopPropagation: true
        });

        swiper.on("activeIndexChange", ({ realIndex }) => {
          this.current = this.items[realIndex];
          this.sourceIndex = realIndex;
          this.zoomPercent = 1;
          this.imgRotate = 0;
        });

        swiper.init();
        this.swiper = swiper;
      });
    },
    shouldRenderImage(index) {
      return this.visible && Math.abs(index - this.sourceIndex) <= 2;
    },
    resetPreviewState() {
      this.current = {};
      this.items = [];
      this.callback = null;
      this.loading = false;
      this.sourceIndex = 0;
      this.zoomPercent = 1;
      this.imgRotate = 0;
    },
    onError() {
      this.loading = false;
      this.$message({
        message: intl.$t("图片加载失败#!!!#src/pages/H5/Cloud/components/imagepreview/template.vue_2"),
        type: "error",
        duration: 2000
      });
    },
    onDownload() {
      if (this.callback) this.callback(this.current);
    },
    onZoomOut() {
      this.zoomPercent += 0.1;
    },
    onZoomIn() {
      this.zoomPercent -= 0.1;
    },
    onRotate() {
      this.imgRotate += 90;
    },
    onNext() {
      if (this.swiper && this.canNext) this.swiper.slideNext();
    },
    onPrev() {
      if (this.swiper && this.canPrev) this.swiper.slidePrev();
    }
  },
  destroyed() {
    this.onDialogClosed();
  }
};
</script>

<style lang="scss">
.image-preview {
  width: 100% !important;
  height: 100vh !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  background-color: rgba(18, 19, 23, 0.4) !important;
  border-radius: 8px !important;

  .moo-dialog__header {
    display: none;
    padding: 0 !important;
    margin: 0 !important;
  }

  .moo-dialog__body {
    position: relative;
    height: 100vh;
    padding: 0 !important;

    .image-preview-body {
      width: 100%;
      height: 100%;

      .content-body {
        height: 100%;
      }

      .ip-header {
        z-index: 9;
      }

      .ip-tools-bar {
        position: absolute;
        z-index: 9;
        bottom: 24px;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 48px;
      }

      #image-box-swiper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      .swiper-wrapper {
        align-items: center;
      }

      .swiper-slide {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
